<template>
  <div class="gui-flex gui-flex-rows">
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>
        <div class="actual-purchase">
          <div class="slitek">
            <zaplaceno-procent :title="procento>=100?'Vše zaplaceno':'Rozespořeno'" :procento="procento" :obrazek="obrazek" :pocet_rozesporenych_g="pocet_rozesporenych_g"></zaplaceno-procent>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  props: {
    pocet_rozesporenych_g: Number,
    procento: Number,
    obrazek: String
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Klienti/GrafSporeni.vue